import { Activity } from '@/interface/KKC/mgm';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum PagesNeedReturn {
  PreviewRewardRecords,
}

interface CommonState {
  isEnterPreview: boolean;
  currentActivity: Activity | undefined; // 当前活动
}

const initialState: CommonState = {
  isEnterPreview: false,
  currentActivity: {},
};

const mgmSlice = createSlice({
  name: 'mgmStore',
  initialState,
  reducers: {
    setIsEnterPreview(state: CommonState, action: PayloadAction<boolean>) {
      state.isEnterPreview = action.payload;
    },
    setCurrentActivity(state: CommonState, action: PayloadAction<Activity | undefined>) {
      state.currentActivity = action.payload;
    },
  },
});

const { setIsEnterPreview, setCurrentActivity } = mgmSlice.actions;

export { setIsEnterPreview, setCurrentActivity };

export default mgmSlice.reducer;
